export default __webpack_public_path__ + "static/media/banco-davivienda.f1c44cff.svg";